
// ------------------------
// Vars globais

window.ajaxExecuting = false;


// ------------------------
// Funcões gerais

$.fn.toastAbrir = function(msg, tipo, cmp) {
	if (tipo == "err") {
		$(".msg-panel .titulo").html("ATENÇÃO");
		$(".msg-panel .titulo").removeClass('ok').addClass('erro');
		$(".msg-panel .mensagem").removeClass('ok').addClass('erro');
		$(".msg-panel .btn").removeClass('btn-success').addClass('btn-danger');
		
		$(".msg-panel .mensagem").html(msg);
		$(".msg-panel .btn").data("toast-cmp", cmp);

		$(".msg-panel-bg").css("display", "block");
		$(".msg-panel").fadeIn("fast");

	} else {
		$(".msg-ok .mensagem").removeClass('erro').addClass('ok');
		$(".msg-ok .btn").removeClass('btn-danger').addClass('btn-success');

		$(".msg-ok .mensagem").html(msg);
		$(".msg-ok").fadeIn("fast");

		window.setTimeout(function() {
			$.fn.toastFechar();
		}, 2500);
	
	}
} 


$.fn.toastFechar = function() {
	$(".msg-panel-bg").css("display", "none");
	$(".msg-panel").fadeOut("fast");
	
	$(".msg-ok").fadeOut("fast");
}


$.fn.loadingAtivar = function() { 
	$(".btn").prop("disabled", true);
	$(".msg-loading").fadeIn("fast");
}


$.fn.loadingDesativar = function() { 
	$(".btn").prop("disabled", false);
	$(".msg-loading").fadeOut("fast");
}


$.fn.modalAtivar = function(id, titulo, html) { 
	if (!id) id = "modal-imagem";

	var $modal = $("#" + id);

	if (!titulo) $modal.find(".modal-title").html("");
	else $modal.find(".modal-title").html(titulo);

	$modal.find(".modal-body").html(html); 

	var options = {};
	$modal.modal(options);
}


$.fn.urlIdFormatar = function(str) {
	var string = str.toLowerCase();
	var mapaAcentosHex 	= {
		a : /[\xE0-\xE6]/g,
		e : /[\xE8-\xEB]/g,
		i : /[\xEC-\xEF]/g,
		o : /[\xF2-\xF6]/g,
		u : /[\xF9-\xFC]/g,
		c : /\xE7/g,
		n : /\xF1/g
	};

	for (var letra in mapaAcentosHex) {
		var exp = mapaAcentosHex[letra];
		string  = string.replace(exp, letra)
	}

	string = string.replace(/\s{1,}/g, '-');
	string = string.replace(/\!{1,}/g, '-');
	string = string.replace(/\({1,}/g, '-');
	string = string.replace(/\){1,}/g, '-');
	string = string.replace(/\[{1,}/g, '-');
	string = string.replace(/\]{1,}/g, '-');
	string = string.replace(/\{{1,}/g, '-');
	string = string.replace(/\}{1,}/g, '-');
	string = string.replace(/\:{1,}/g, '-');
	string = string.replace(/\;{1,}/g, '-');
	string = string.replace(/\.{1,}/g, '-');
	string = string.replace(/\,{1,}/g, '-');
	string = string.replace(/\'{1,}/g, '-');
	string = string.replace(/\"{1,}/g, '-');
	string = string.replace(/\@{1,}/g, '-');
	string = string.replace(/\#{1,}/g, '-');
	string = string.replace(/\${1,}/g, '-');
	string = string.replace(/\%{1,}/g, '-');
	string = string.replace(/\&{1,}/g, '-');
	string = string.replace(/\*{1,}/g, '-');
	string = string.replace(/\?{1,}/g, '-');

	return string;
}


$.fn.urlFormatar = function(str) {
	var string = str.toLowerCase();
	if (string != "" && string.indexOf("http://") == -1 && string.indexOf("https://") == -1) string = "http://" + string;
	return string;
}


$.fn.scrollExecutar = function(pos, seletor, align) {

	if (!seletor) seletor = "";
	if (!align) align = "top";

	if (seletor) {
		var _obj     = $(seletor);
		var position = _obj.position();
		var height   = _obj.height();

		if (align == "top") pos = parseFloat(position.top);
		else if (align == "bottom") pos = parseFloat(position.top) + parseFloat(height);
	} 

	if (isNaN(pos)) pos = 0;

	$("html, body").animate({scrollTop: pos}, 750);  
}


$.fn.urlRedirecionar = function(url) { 
	if (typeof(url) != "undefined" && url != "") window.location.href = url;
}


$.fn.actConfirmar = function(msg, callback, btnOk, btnCancel) { 
	if (typeof(msg) == "undefined" || !msg) msg = "Confirmar operação?";
	if (typeof(btnOk) == "undefined" || !btnOk) btnOk = "Confirmar";
	if (typeof(btnCancel) == "undefined" || !btnCancel) btnCancel = "Desistir";
	if (msg.indexOf("?") == -1) msg+= "?";

	$.confirm({
		title: 'CONFIRMAR AÇÃO',
		content: msg,
		animation: 'opacity',
		closeAnimation: 'opacity',
		animationSpeed: 250,
		buttons: {
			confirm: {
				text: btnOk,
				btnClass: 'btn-success',
				keys: ['enter'],
				action: function () {
					callback();
				}
			},
			cancel: {
				text: btnCancel,
				btnClass: 'btn-danger',
				keys: ['escape'],
				action: function () {
					return true;
				}
			},
		}
	}); 
}


$.fn.formSalvarVerificarAlteracao = function() {
	// TO DO
	// Em páginas com UPLOAD existe BUG
	// Reconhece o clique de download.

	var frm = $("#frmSalvar");

	/*if (typeof(frm) != "undefined" && frm.attr("id") != "undefined") { 
		frm.data('dados', frm.serialize());

		$(":submit").click(function() {
			window.onbeforeunload = null;
		});

		window.onbeforeunload = function() {
			if (frm.data('dados') !== frm.serialize()) {
				return "Suas alterações não foram salvas.\nAo sair todos os dados serão perdidos!";
			}
		}
	}*/
}


$.fn.formSalvarExecutarAjax = function(obj) { 

	if (window.ajaxExecuting) return;

	$.fn.loadingAtivar();
	$.fn.scrollExecutar(0);
	
	var formID = $(obj).attr("id");
	var campos = $(obj).serialize();
	var action = $(obj).attr("action");
	
	var jqxhr = $.post( 
		action, 
		campos,
		function(data) {
			
			$.fn.loadingDesativar();
			
			if (data.et == 1) {
				$.fn.toastAbrir(data.emsg, "err", data.ecmp);

			} else if (typeof(data.url) == "undefined" && data.et == 0) {
				$.fn.toastAbrir(data.emsg, "ok", data.ecmp);

			} else if (typeof(data.url) != "undefined" && data.et == 0 && data.url != "") {
				$.fn.urlRedirecionar(data.url);
			
			} else {
				$.fn.toastAbrir("Falha no processamento da requisição - COD: PHP ERROR", "err");

			} 
		}
	)
	.fail(
		function() {
			$.fn.loadingDesativar();
			$.fn.toastAbrir("Falha no processamento da requisição - COD: AJAX ERROR", "err");
		}
	);
}

$.fn.formSalvarInscricaoAjax = function(obj) { 

	if (window.ajaxExecuting) return;

	$.fn.loadingAtivar();
	// $.fn.scrollExecutar(0);
	
	var formID = $(obj).attr("id");
	var campos = $(obj).serialize();
	var action = $(obj).attr("action");
	
	var jqxhr = $.post( 
		action, 
		campos,
		function(data) {
			
			$.fn.loadingDesativar();
			
			if (data.et == 1) {
				$.fn.toastAbrir(data.emsg, "err", data.ecmp);

			} else if (typeof(data.url) == "undefined" && data.et == 0) {
				$.fn.toastAbrir(data.emsg, "ok", data.ecmp);

			} else if (typeof(data.url) != "undefined" && data.et == 0 && data.url != "") {
				$.fn.urlRedirecionar(data.url);
			
			} else {
				$.fn.toastAbrir("Falha no processamento da requisição - COD: PHP ERROR", "err");

			} 
		}
	)
	.fail(
		function() {
			$.fn.loadingDesativar();
			$.fn.toastAbrir("Falha no processamento da requisição - COD: AJAX ERROR", "err");
		}
	);
}


$.fn.formBuscaExecutarAjax = function(obj) { 
	if (window.ajaxExecuting) return;

	$.fn.loadingAtivar();
	//$.fn.scrollExecutar(0, ".g-titulo", "bottom");
	$.fn.scrollExecutar(0);
		
	var formID = $(obj).attr("id");
	var campos = $(obj).serialize();
	var action = $(obj).attr("action");

	if (action.indexOf("?") == -1) action+= "?";

	var url = action + "&" + campos;
		
	$(".mancha").load(url + " #divRegDados", function(response, status, xhr) {
		if (status == "error") $.fn.toastAbrir("Falha no processamento da requisição - COD: PHP ERROR", "err");
		else window.history.pushState("", document.title, url);
	 	
		$.fn.loadingDesativar();
	});
}


$.fn.formRegExecutarAjax = function(obj, urlAcao) { 
	if (window.ajaxExecuting) return;

	$.fn.loadingAtivar();
	$.fn.scrollExecutar(0); 
		
	var formID = $(obj).attr("id");
	var campos = $(obj).serialize();
	var action = urlAcao;
		
	var jqxhr = $.post( 
		action, 
		campos,
		function(data) {
			$.fn.loadingDesativar();
			
			if (data.et == 1) $.fn.toastAbrir(data.emsg, "err");
			else if (data.et == 0) {
				$.fn.toastAbrir(data.emsg, "ok");
				$.fn.formBuscaExecutarAjax($("#frmBusca"));
			}
		}
	)
	.fail(
		function() {
			$.fn.loadingDesativar();
			$.fn.toastAbrir("Falha no processamento da requisição - COD: AJAX ERROR", "err");
		}
	);
}

$.fn.formIniciarExecutarAjax = function(obj) {

	if (window.ajaxExecuting) return;

	$.fn.loadingAtivar();
	$.fn.scrollExecutar(0); 
		
	var formID = $(obj).attr("id");
	var campos = $(obj).serialize();
	var action = $(obj).attr("action");
		
	var jqxhr = $.post( 
		action, 
		campos,
		function(data) {
			$.fn.loadingDesativar();
			
			if (data.et == 1) $.fn.toastAbrir(data.emsg, "err");
			else if (data.et == 0) {

				var url = $("#url").val();


				if (url) {
					$("#iniciarInsc").attr('action', url).removeClass('actFormIniciarExecutarAjax').submit();
					// $.fn.toastAbrir(data.emsg, "ok");
					// $.fn.urlRedirecionar(url);
				} else {
					var cpf = $('#txtCpf').val();
					$("#txtLogin").val(cpf);
					$('.insere-cadastro').removeClass('hide').show();
					$('.insere-cpf').hide();
				}
				// $.fn.formBuscaExecutarAjax($("#frmBusca"));
			}
		}
	)
	.fail(
		function() {
			$.fn.loadingDesativar();
			$.fn.toastAbrir("Falha no processamento da requisição - COD: AJAX ERROR", "err");
		}
	);
}


$.fn.formSalvarEquipeAjax = function(ordem) {

	if (window.ajaxExecuting) return;

	$.fn.loadingAtivar();

	var obj = $(document).find("#participante-" + ordem);

	var cod         = $("#codProjetoEquipe-" + ordem).val();
	var codProjeto  = $("#cod").val();
	var txtNome     = $("#txtNome-" + ordem).val();
	var txtSemestre = $("#txtSemestre-" + ordem).val();
	var txtEmail    = $("#txtEmail-" + ordem).val();
	var txtTel      = $("#txtTel-" + ordem).val();
	var txtEndereco = $("#txtEndereco-" + ordem).val();
	var txtBairro   = $("#txtBairro-" + ordem).val();
	var txtCidade   = $("#txtCidade-" + ordem).val();
	var slcEstado   = $("#slcEstado-" + ordem).val();
	var txtCep      = $("#txtCep-" + ordem).val();
	var txtIdade    = $("#txtIdade-" + ordem).val();
	var txtOrdem    = ordem;

	var campos = {
		cod : cod,
		codProjeto : codProjeto,
		txtNome : txtNome,
		txtSemestre : txtSemestre,
		txtEmail : txtEmail,
		txtTel : txtTel,
		txtEndereco : txtEndereco,
		txtBairro : txtBairro,
		txtCidade : txtCidade,
		slcEstado : slcEstado,
		txtCep : txtCep,
		txtIdade : txtIdade,
		txtOrdem : txtOrdem
	};

	var action = $("#acao").val();

	var jqxhr = $.post( 
		action, 
		campos,
		function(data) {
			$.fn.loadingDesativar();
			
			if (data.et == 1) {
				// $.fn.scrollExecutar(0);
				$.fn.toastAbrir(data.emsg, "err", data.ecmp);
			} else if (data.et == 0) {
				// var pos = ($(".send-team").offset().top) - 75;
				// $.fn.scrollExecutar(pos);
				$("#codProjetoEquipe-" + ordem).val(data.dados.cod);
				$(".send-team").removeClass('hidden').show('fast');
				$.fn.toastAbrir(data.emsg, "ok", data.ecmp);
			} else {
				// $.fn.scrollExecutar(0);
				$.fn.toastAbrir("Falha no processamento da requisição - COD: PHP ERROR", "err");

			} 
		}
	)
	.fail(
		function() {
			$.fn.loadingDesativar();
			$.fn.toastAbrir("Falha no processamento da requisição - COD: AJAX ERROR", "err");
		}
	);
}


// ------------------------
// Funcões de carregamento

$(document).ready(function() {


	// ------------------------
	// Funcões gerais
	
	$(this).on("click", "a[href='#']", function(event) {
		event.preventDefault();
	});

	$(this).ajaxStart(function() {
		window.ajaxExecuting = true;
	});

	$(this).ajaxStart(function() {
		window.ajaxExecuting = false;
	});

	$(this).on("click", ".actPainelLateral", function(event) {
		event.preventDefault();

		$(".g-lateral").toggleClass("fechado");
		$(".g-lateral .bar-panel").toggleClass("fechado");
		$(".g-lateral .bar-close").toggleClass("fechado");
		$(".g-conteudo").toggleClass("fechado");
	});

	$(".msg-panel").each(function() {
		var _self = $(this);
		var exb = _self.data("toast-exb");
		var msg = _self.data("toast-msg");
		var tip = _self.data("toast-tip");

		if (exb == "S") $.fn.toastAbrir(msg, tip);
	});

	$("p.reg").each(function() {
		var val = $(this).text();
		if (!val) $(this).text("-");
	});

	$("#frmSalvar").each(function() {
		$.fn.formSalvarVerificarAlteracao();
	});


	// ------------------------
	// Funções Bootstrap

	/*$("html").tooltip({
	    selector: '[data-toggle="tooltip"]',
	    container: 'body',
	    delay: { "show": 500, "hide": 1 }
	}); */


	// ------------------------
	// Máscaras para campos de formulários
	
	$(".f-numero-int").mask("#", {maxlength: false});
	$(".f-numero-float").mask("#.##0,0", {reverse: true, maxlength: false});
	$(".f-numero-float-1").mask("#.##0,0", {reverse: true, maxlength: false});
	$(".f-numero-float-2").mask("#.##0,00", {reverse: true, maxlength: false});
	$(".f-numero-float-3").mask("#.##0,000", {reverse: true, maxlength: false});
	$(".f-numero-float-4").mask("#.##0,0000", {reverse: true, maxlength: false});
	$(".f-moeda").mask('#.##0,00', {reverse: true, maxlength: false});
	
	var masks = ['(00) 00000-0000', '(00) 0000-00009'],
		maskBehavior = function(val, e, field, options) {
		return val.length > 14 ? masks[0] : masks[1];
	};
	
	$('.f-telefone-9-digitos').mask(maskBehavior, {onKeyPress: 
		function(val, e, field, options) {
		   field.mask(maskBehavior(val, e, field, options), options);
	   	}
	});
	
	$(".f-ddi").mask("00");
	$(".f-ddd").mask("00");
	$(".f-telefone").mask("900000000");
	$(".f-cpf").mask("000.000.000-00");
	$(".f-cnpj").mask("00.000.000/0000-00");
	$(".f-cep").mask("00000-000");
	$(".f-data").mask("00/00/0000");
	$(".f-data-mes-ano").mask("00/0000");
	$(".f-data-mes-ano-2").mask("00/00");
	$(".f-data-hora").mask("00/00/0000 00:00");
	
	$(".f-data-calendar").keydown(function(k) {
		if (k.keyCode == 8 || k.keyCode == 46) return true;
		else return false;
	});
	
	// $(".f-data-calendar").datepicker({
	// 	changeMonth: true,
	// 	changeYear: true,
	// 	constrainInput: true,
	// 	dateFormat: 'dd/mm/yy',
	// 	navigationAsDateFormat: true, 
	// 	showAnim: 'slideDown'
	// });
	
	// Desabilitar click com o botão direito

	$(this).on("contextmenu", ".f-data-calendar", function(e) {
		e.preventDefault();
	});

	// Para restringir datas passadas ou futuras 
	// Basta adicionar o atributo min-date ou max-date 
	// Com a data no formato dd/mm/aaaa (d/m/Y) no input.f-data-calendar
	
	// $(".f-data-calendar[max-date]").each(function() {
	// 	$(this).datepicker("option", "maxDate", new Date(String($(this).attr("max-date")).replace(/([0-9]{2})\/([0-9]{2})\/([0-9]{4})/, "$3, $2, $1")));
	// });
	
	// $(".f-data-calendar[min-date]").each(function() {
	// 	$(this).datepicker("option", "minDate", new Date(String($(this).attr("min-date")).replace(/([0-9]{2})\/([0-9]{2})\/([0-9]{4})/, "$3, $2, $1")));
	// });
	

	// ------------------------
	// Ações

	// Form BUSCA

	$(this).on("submit", ".actFormBuscaExecutarAjax", function(event) {
		event.preventDefault();

		$("input[name=bsc]").val("ativar");
		$("input[name=bscPgn]").val("1");

		$.fn.formBuscaExecutarAjax(this);
	});

	$(this).on("click", ".actFormBuscaLimpar", function(event) {
		event.preventDefault();

		$("#frmBusca :input").val('');
		$("#frmBusca :checkbox").prop("checked", false); 

		$("input[name=bsc]").val("limpar");
		$("input[name=bscPgn]").val("1");
		$("input[name=bscQtdReg]").val("10");
		$("input[name=bscOrdenar]").val("");
		$("input[name=bscSentido]").val("");

		$.fn.formBuscaExecutarAjax($("#frmBusca"));
	});

	$(this).on("click", ".actFormBuscaOrdenar", function(event) {
		event.preventDefault();

		$("input[name=bsc]").val("ativar");
		$("input[name=bscPgn]").val("1");
		$("input[name=bscOrdenar]").val($(this).data("ordenar-coluna"));
		$("input[name=bscSentido]").val($(this).data("ordenar-sentido"));

		$.fn.formBuscaExecutarAjax($("#frmBusca")); 
	});

	$(this).on("change", ".actFormBuscaAlterarQtdReg", function(event) {
		event.preventDefault();

		$("input[name=bsc]").val("ativar");
		$("input[name=bscPgn]").val("1");
		$("input[name=bscQtdReg]").val($(this).val());

		$.fn.formBuscaExecutarAjax($("#frmBusca")); 
	});

	$(this).on("click", ".actFormBuscaAlterarPgn", function(event) {
		event.preventDefault();

		$("input[name=bsc]").val("ativar");
		$("input[name=bscPgn]").val($(this).data("pgn"));

		$.fn.formBuscaExecutarAjax($("#frmBusca")); 
	});


	// Form REG

	$(this).on("change", ".actFormRegMarcar", function() {
		var _obj = $(this).parents("tr").find(":checkbox");
		_obj.prop("checked", true);
		_obj.parents("tr").addClass("reg-ativo"); 
	});

	$(this).on("click", ".actFormRegSelecionar", function() {
		var _self = $(this);
		var checked = _self.prop("checked");

		if (checked) _self.parents("tr").addClass("reg-ativo");
		else _self.parents("tr").removeClass("reg-ativo");
	});

	$(this).on("click", ".actFormRegSelecionarTodos", function() {
		var _self = $(this);
		var checked = _self.prop("checked");

		$("input[name^=chkReg]").each(function() {
			var _self2 = $(this);

			if (checked) {
				_self2.prop("checked", true);
				_self2.parents("tr").addClass("reg-ativo");
			} else {
				_self2.prop("checked", false);
				_self2.parents("tr").removeClass("reg-ativo");
			}
		});
	});

	$(this).on("click", ".actFormRegExecutarMultiplo", function(event) {
		event.preventDefault();
		
		var _self = $(this);
		var url = _self.data("url-acao");
		var msg = _self.data("msg-acao");

		$.fn.actConfirmar(
			msg, 
			function() {
				$.fn.formRegExecutarAjax($("#frmReg"), url);
			}
		);
	});


	// Form SALVAR

	$(this).on("submit", ".actFormSalvarExecutarAjax", function(event) {
		event.preventDefault();

		var _self = $(this);
		var msg = _self.data("msg-confirm");

		if (typeof(msg) != "undefined" && msg) {
			$.fn.actConfirmar(
				msg, 
				function() {
					$.fn.formSalvarExecutarAjax(_self);
				}
			);
			
		} else $.fn.formSalvarExecutarAjax(this);
	});

	$(this).on('submit', '.actFormIniciarExecutarAjax', function(event){
		event.preventDefault();
		$.fn.formIniciarExecutarAjax(this);
	});

	$(this).on("click", ".actFormSalvarCancelar", function(event) {
		event.preventDefault();

		var _self = $(this);
		var url = _self.data("url-cancelar");
		var msg = _self.data("msg-cancelar");

		if (typeof(msg) == "undefined" || !msg) msg = "Deseja realmente cancelar?<br>As alterações não salvas serão perdidos.";

		$.fn.actConfirmar(
			msg, 
			function() {
				$.fn.urlRedirecionar(url);
			}
		);
	});

	$(this).on("click", ".actFormSalvarVoltar", function(event) {
		event.preventDefault();

		var _self = $(this);
		var url = _self.data("url-cancelar");
		$.fn.urlRedirecionar(url);
	});

	$(this).on("click", ".actFormSalvarDefinirRetorno", function() {
		var url = $(this).data("url-retorno");
		$("#url").val(url);
	});

	$(this).on("click", ".actFormSalvarExcluir", function(event) {
		event.preventDefault();

		var _self = $(this);
		var url = _self.data("url-acao");
		var msg = _self.data("msg-acao");
		var cod = _self.data("cod-acao");

		url += url + "&cod=" + cod;

		$.fn.actConfirmar(
			msg, 
			function() {
				$.fn.urlRedirecionar(url);
			}
		);
	});

	$(this).on("keyup blur", ".actFormUrlFormatar", function(event) {
        var v = $(this).val();
        $(this).val($.fn.urlFormatar(v));
    });


	// Toast
	
	$(this).on("click", ".actToastAbrir", function(event) {
		event.preventDefault();

		var tip = $(this).data("toast-tip");
		var msg = $(this).data("toast-msg");

		$.fn.toastAbrir(msg, tip);
	});

	$(this).on("click", ".actToastFechar", function(event) {
		event.preventDefault();

		var cmp = $(this).data("toast-cmp");
		if (cmp) $("#" + cmp).focus();

		$.fn.toastFechar();
	});


	// Modal

	$(this).on("click", ".actModalAtivar", function(event) {
		event.preventDefault();

		var $obj   = $(this);
		var id     = $obj.data("modal-id");
		var titulo = $obj.data("modal-titulo");
		var html   = $obj.find(".modal-html").html();

		$.fn.modalAtivar(id, titulo, html);
	});

	$(this).on("click", ".actFormSalvarEquipeAjax", function(event) {
		event.preventDefault();

		var ordem  = $(this).data("ordem");

		$.fn.formSalvarEquipeAjax(ordem);
	});

	$(this).on("submit", ".actFormSalvarInscricaoAjax", function(event) {
		event.preventDefault();

		var _self = $(this);
		var msg = _self.data("msg-confirm");

		if (!$('#regulamento').is(":checked")) {
			$.fn.toastAbrir("É necessário aceitar o regulamento para continuar", "err", 'txtNome-1');
			return;
		} else {

			if (typeof(msg) != "undefined" && msg) {
				$.fn.actConfirmar(
					msg, 
					function() {
						$.fn.formSalvarInscricaoAjax(_self);
					}
				);
				
			} else $.fn.formSalvarInscricaoAjax(this);
		}
	});


	// $(this).on("submit", ".actFormSalvarExecutarAjax", function(event) {
	// 	event.preventDefault();

	// 	var _self = $(this);
	// 	var msg = _self.data("msg-confirm");

	// 	if (typeof(msg) != "undefined" && msg) {
	// 		$.fn.actConfirmar(
	// 			msg, 
	// 			function() {
	// 				$.fn.formSalvarExecutarAjax(_self);
	// 			}
	// 		);
			
	// 	} else $.fn.formSalvarExecutarAjax(this);
	// });

});


// ------------------------
// Funcões de load de página

$(window).on("load", function (e) {

	if (window.location.hash) {
		var hash = window.location.hash;
		var _obj = $(hash);

		if (typeof(_obj) != "undefined") {
			var pos = _obj.offset();
			$.fn.scrollExecutar(pos.top - 150);
		}
	}

}); 